<template>
  <v-row justify="center" class="pt-xl-4 pt-lg-4 pt-md-4 pt-sm-4 pt-2 px-xl-4 px-lg-4 px-md-4 px-sm-4 px-2 pb-xl-6 pb-lg-6 pb-md-6 pb-sm-2 pb-1" no-gutters>
    <v-col xl="10" lg="9" md="10" sm="12" cols="12">
      <v-card class="mb-4 px-xl-6 px-lg-6 px-md-6 px-sm-4 px-4 pt-2 pb-xl-5 pb-lg-5 pb-md-5 pb-sm-5 pb-5 text-left" outlined>
        <v-skeleton-loader type="list-item-three-line" v-for="i in 4" :key="i + '_item'"></v-skeleton-loader>
        <v-skeleton-loader type="list-item"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-avatar-two-line"></v-skeleton-loader>
        <v-skeleton-loader type="list-item-avatar-two-line"></v-skeleton-loader>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'TrackShippingLoader'
}
</script>
